const SITE_URL = 'https://lacapillahotel.com';

const seoConfig = {
  es: {
    home: {
      title: 'Hotel La Capilla | Hotel Boutique en Ruta del Vino, San Miguel de Allende',
      description: 'Hotel boutique de lujo en la Ruta del Vino entre San Miguel de Allende y Dolores Hidalgo. Suites exclusivas, bodas, naturaleza y experiencias únicas en el corazón de México.',
    },
    reservas: {
      title: 'Reservaciones Casa Hotel | Hotel La Capilla',
      description: 'Reserva tu suite en Hotel La Capilla Casa Hotel. Habitaciones Estándar, Junior Suite y Master Suite con vistas al viñedo, desayuno incluido y check-in express.',
    },
    boutique: {
      title: 'Hotel Boutique | Hotel La Capilla',
      description: 'Descubre nuestro Hotel Boutique exclusivo. Suites de lujo con diseño contemporáneo, terraza privada y los mejores servicios en la Ruta del Vino del Bajío.',
    },
    bodas: {
      title: 'Bodas y Eventos | Hotel La Capilla',
      description: 'Celebra tu boda de ensueño en Hotel La Capilla. Espacios exclusivos rodeados de viñedos, paquetes all-inclusive para bodas íntimas y grandes celebraciones.',
    },
  },
  en: {
    home: {
      title: 'Hotel La Capilla | Boutique Hotel on the Wine Route, San Miguel de Allende',
      description: 'Luxury boutique hotel on the Wine Route between San Miguel de Allende and Dolores Hidalgo. Exclusive suites, weddings, nature and unique experiences in the heart of Mexico.',
    },
    reservas: {
      title: 'Casa Hotel Reservations | Hotel La Capilla',
      description: 'Book your suite at Hotel La Capilla Casa Hotel. Standard, Junior Suite and Master Suite rooms with vineyard views, breakfast included and express check-in.',
    },
    boutique: {
      title: 'Boutique Hotel | Hotel La Capilla',
      description: 'Discover our exclusive Boutique Hotel. Luxury suites with contemporary design, private terrace and the finest services on the Bajío Wine Route.',
    },
    bodas: {
      title: 'Weddings & Events | Hotel La Capilla',
      description: 'Celebrate your dream wedding at Hotel La Capilla. Exclusive venues surrounded by vineyards, all-inclusive packages for intimate and grand celebrations.',
    },
  },
  de: {
    home: {
      title: 'Hotel La Capilla | Boutique-Hotel an der Weinstraße, San Miguel de Allende',
      description: 'Luxus-Boutique-Hotel an der Weinstraße zwischen San Miguel de Allende und Dolores Hidalgo. Exklusive Suiten, Hochzeiten, Natur und einzigartige Erlebnisse im Herzen Mexikos.',
    },
    reservas: {
      title: 'Casa Hotel Reservierungen | Hotel La Capilla',
      description: 'Buchen Sie Ihre Suite im Hotel La Capilla Casa Hotel. Standard-, Junior-Suite- und Master-Suite-Zimmer mit Weinbergblick, Frühstück inklusive.',
    },
    boutique: {
      title: 'Boutique-Hotel | Hotel La Capilla',
      description: 'Entdecken Sie unser exklusives Boutique-Hotel. Luxussuiten mit zeitgenössischem Design, privater Terrasse und erstklassigem Service an der Weinstraße.',
    },
    bodas: {
      title: 'Hochzeiten & Events | Hotel La Capilla',
      description: 'Feiern Sie Ihre Traumhochzeit im Hotel La Capilla. Exklusive Veranstaltungsorte inmitten von Weinbergen, All-inclusive-Pakete für intime und große Feiern.',
    },
  },
  fr: {
    home: {
      title: 'Hotel La Capilla | Hôtel Boutique sur la Route des Vins, San Miguel de Allende',
      description: 'Hôtel boutique de luxe sur la Route des Vins entre San Miguel de Allende et Dolores Hidalgo. Suites exclusives, mariages, nature et expériences uniques au cœur du Mexique.',
    },
    reservas: {
      title: 'Réservations Casa Hotel | Hotel La Capilla',
      description: 'Réservez votre suite à l\'Hotel La Capilla Casa Hotel. Chambres Standard, Junior Suite et Master Suite avec vue sur les vignobles, petit-déjeuner inclus.',
    },
    boutique: {
      title: 'Hôtel Boutique | Hotel La Capilla',
      description: 'Découvrez notre Hôtel Boutique exclusif. Suites de luxe au design contemporain, terrasse privée et les meilleurs services sur la Route des Vins du Bajío.',
    },
    bodas: {
      title: 'Mariages & Événements | Hotel La Capilla',
      description: 'Célébrez votre mariage de rêve à l\'Hotel La Capilla. Espaces exclusifs entourés de vignobles, forfaits tout compris pour mariages intimes et grandes célébrations.',
    },
  },
};

export const HOTEL_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Hotel',
  name: 'Hotel La Capilla',
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.ico`,
  image: `${SITE_URL}/og-image.jpg`,
  description: 'Hotel boutique de lujo en la Ruta del Vino entre San Miguel de Allende y Dolores Hidalgo, Guanajuato, México.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'San Miguel de Allende',
    addressRegion: 'Guanajuato',
    addressCountry: 'MX',
  },
  telephone: '+52 418 178 9398',
  starRating: {
    '@type': 'Rating',
    ratingValue: '5',
  },
  amenityFeature: [
    { '@type': 'LocationFeatureSpecification', name: 'WiFi', value: true },
    { '@type': 'LocationFeatureSpecification', name: 'Parking', value: true },
    { '@type': 'LocationFeatureSpecification', name: 'Pool', value: true },
  ],
  sameAs: [
    'https://www.facebook.com/p/La-Capilla-Hotel-100064031587652/',
    'https://www.instagram.com/lacapilla.hotel/',
  ],
};

export function getPageSEO(lang, page) {
  const data = seoConfig[lang]?.[page] || seoConfig.es[page] || seoConfig.es.home;
  return data;
}

export default seoConfig;
